import React from "react";
import { ArrowUpRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { cn } from "@/lib/utils";
const works = [{
  title: "Industrial Flake",
  category: "450 SQ FT • Garage",
  image: "https://valleyvibecoatings.com/wp-content/uploads/2026/03/website-flake.jpg?v=vy9bw8niwk",
  link: "#",
  size: "small"
}, {
  title: "RESIDENTIAL METALLIC",
  category: "900 SQ FT • RESIDENCE",
  image: "https://valued-kid.10web.cloud/wp-content/uploads/2026/03/website-7.jpg?v=dvhq9l8f1em",
  link: "#",
  size: "small"
}, {
  title: "Residential Metallic",
  category: "2,000 SQ FT • Residence",
  image: "https://valued-kid.10web.cloud/wp-content/uploads/2026/03/website-4-scaled.jpg?v=08w0cp60r63",
  link: "https://example.com/residential-metallic",
  size: "small"
}];
export default function CuratedDigitalWorks() {
  return <section data-section-id="46944" id="the-transformation-gallery" className="dark bg-background text-foreground py-24 px-4 md:px-8 lg:px-12 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        
        <div className="mb-16 md:mb-24 flex flex-col md:flex-row md:items-end justify-between gap-8">
          <div className="max-w-2xl">
            <h2 className="text-foreground font-sans text-4xl md:text-5xl lg:text-6xl leading-tight mb-6 uppercase tracking-wider font-bold">
              The Transformation Gallery
            </h2>
            <p className="text-muted-foreground text-lg md:text-xl font-light max-w-lg">
              Witness the metamorphosis of ordinary concrete into high-performance art. 
              Precision-engineered surfaces for elite residential and commercial interiors.
            </p>
          </div>
          <div className="shrink-0">
            <Link to="#" className="inline-flex items-center gap-2 text-foreground hover:text-foreground/80 transition-colors border-b border-foreground/30 pb-1 text-lg uppercase tracking-widest font-medium">
              Explore All Finishes
              <ArrowUpRight className="w-5 h-5" />
            </Link>
          </div>
        </div>

        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6 lg:gap-8">
          {works.map((work, i) => <div key={i} data-index={i} className={cn("group relative overflow-hidden w-full", work.size === "large" ? "md:col-span-2" : "md:col-span-1")}>
              <Link to={work.link} className="block w-full h-full cursor-pointer">
                <AspectRatio ratio={4 / 5} className="w-full h-full bg-muted">
                  <img src={work.image} alt={work.title} className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-105" />
                  
                  
                  <div className="absolute inset-0 bg-black/80 backdrop-blur-sm translate-y-full group-hover:translate-y-0 transition-transform duration-500 ease-out flex flex-col justify-center items-center text-center p-8">
                    <span className="text-white/70 text-sm tracking-widest uppercase mb-3 translate-y-4 group-hover:translate-y-0 transition-transform duration-500 delay-100 font-medium">
                      {work.category}
                    </span>
                    <h3 className="text-white font-sans text-3xl md:text-4xl mb-6 translate-y-4 group-hover:translate-y-0 transition-transform duration-500 delay-150 uppercase tracking-wide font-bold">
                      {work.title}
                    </h3>
                    <span className="inline-flex items-center gap-2 text-white border-b border-white/30 pb-1 translate-y-4 group-hover:translate-y-0 transition-transform duration-500 delay-200 uppercase text-xs tracking-widest">
                      View System Details
                      <ArrowUpRight className="w-4 h-4" />
                    </span>
                  </div>
                </AspectRatio>
              </Link>
            </div>)}
        </div>
      </div>
    </section>;
}